import type { ExternalUser, ExternalUserDTO } from '@/types/external-users.types';

export const mapExternalUserFromDTO = (dto: ExternalUserDTO): ExternalUser => ({
  id: dto.id,
  name: dto.name,
  email: dto.email,
  phone: dto.phone,
  deptOrg: dto.departmentOrganization,
  status: dto.status,
  sixCount: dto.sixCount,
  createdByAccount: dto.createdByAccount.trim(),
});

export const mapExternalUsersFromDTO = (dtos: ExternalUserDTO[]): ExternalUser[] =>
  dtos.map(mapExternalUserFromDTO);
